(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('BookingDetailController', BookingDetailController);

    BookingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Booking', 'EndCustomer', 'Treatment', 'Coupon', 'Practitioner'];

    function BookingDetailController($scope, $rootScope, $stateParams, previousState, entity, Booking, EndCustomer, Treatment, Coupon, Practitioner) {
        var vm = this;

        vm.booking = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:bookingUpdate', function(event, result) {
            vm.booking = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
